import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import Pdfviewer  from "../report/pdfviewer";
const Showimage = ({
  type = "",
  isOpen,
  header,
  onCancel,
  message,
  imageurl,
  size = "xl",
}) => {
  const [amountselect, setamountselect] = useState(1);
  const handelOnClick = (id) => {
    setamountselect(id);
  };
  // const toggle
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader toggle={onCancel}>
          <i className="bi bi-image-fill fs-5 text-primary me-2"></i>{" "}
          <span className="fs-4 text-primary fw-bold"> รูปที่แนบมา</span>
        </ModalHeader>
        <ModalBody className="text-center">
          {type === "pdf" ? <Pdfviewer
          id = {imageurl}
          /> 
          
          
          : (
            <>
              <img src={imageurl} className="img-fluid"  width={400} height={500} alt="..."></img>
              <hr></hr>
            </>
          )}

          {/* {!list && message} */}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Showimage;